import { api } from "../intreceptor/apiInterceptor";
import { API_ENDPOINTS } from "./api.endpoints";
import {
    User,
    Role,
    UserCreateDTO,
    UserUpdateDTO,
    PaginatedResponse,
    GetUsersParams
} from "./user.service.types";

interface UserCreateResponse {
    message: string;
    user: User;
    emailError?: string;
}


export const userService = {
    async getUsers(): Promise<User[]> {
        return api.fetch(API_ENDPOINTS.USERS.ALL);
    },

    async getUsersPaginated(params: GetUsersParams): Promise<PaginatedResponse<User>> {
        const queryParams = new URLSearchParams();
        if (params.page) queryParams.append('page', params.page.toString());
        if (params.limit) queryParams.append('limit', params.limit.toString());
        if (params.search) queryParams.append('search', params.search);
        if (params.sortBy) queryParams.append('sortBy', params.sortBy);
        if (params.sortOrder) queryParams.append('sortOrder', params.sortOrder);

        const response = await api.fetch<PaginatedResponse<User>>(`${API_ENDPOINTS.USERS.GET_USERS}?${queryParams.toString()}`);
        return {
            data: response.data,
            totalCount: response.totalCount,
            page: response.page,
            limit: response.limit
        };
    },

    async createUser(userData: UserCreateDTO): Promise<UserCreateResponse> {
        return api.fetch(API_ENDPOINTS.USERS.CREATE, {
            method: API_ENDPOINTS.METHODS.POST,
            body: JSON.stringify({
                name: userData.name,
                email: userData.email,
                mobileNumber: userData.mobileNumber,
                // gender: userData.gender,
                status: userData.status,
                role: userData.role,
                region: userData.region,
                local: userData.local
            }),
        });
    },

    async updateUser(userData: UserUpdateDTO): Promise<User> {
        const { id, ...updateData } = userData;
        return api.fetch(`${API_ENDPOINTS.USERS.BY_ID(id)}`, {
            method: API_ENDPOINTS.METHODS.PUT,
            body: JSON.stringify(updateData),
        });
    },

    async updateUserStatus(userId: string, status: string): Promise<User> {
        return api.fetch(`${API_ENDPOINTS.USERS.STATUS(userId)}`, {
            method: API_ENDPOINTS.METHODS.PATCH,
            body: JSON.stringify({ status }),
        });
    },

    async getUserById(userId: string): Promise<User> {
        return api.fetch(`${API_ENDPOINTS.USERS.BY_ID(userId)}`);
    },

    async deleteUser(userId: string): Promise<void> {
        return api.fetch(`${API_ENDPOINTS.USERS.BY_ID(userId)}`, {
            method: API_ENDPOINTS.METHODS.DELETE,
        });
    },

    async getRoles(): Promise<Role[]> {
        return api.fetch(API_ENDPOINTS.ROLES.ALL);
    }
};
